import React from 'react';
import { Card, CardContent, CardHeader, Divider, Box, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MoreVertIcon from '@mui/icons-material/MoreVert';

interface SectionCardProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
  variant?: 'elevation' | 'outlined';
  noPadding?: boolean;
  className?: string;
}

export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  subtitle,
  icon,
  action,
  children,
  variant = 'outlined',
  noPadding = false,
  className,
}) => {
  const theme = useTheme();

  return (
    <Card
      variant={variant}
      className={className}
      sx={{
        mb: 3,
        boxShadow: variant === 'elevation' ? theme.shadows[1] : 'none',
        '&:hover': {
          boxShadow: variant === 'elevation' ? theme.shadows[4] : 'none',
        },
        transition: 'box-shadow 0.3s ease-in-out',
      }}
    >
      <CardHeader
        avatar={icon}
        title={title}
        titleTypographyProps={{
          variant: 'h6',
          fontWeight: 600,
        }}
        subheader={subtitle}
        action={action || (
          <IconButton size="small" disabled>
            <MoreVertIcon />
          </IconButton>
        )}
        sx={{
          backgroundColor: theme.palette.mode === 'dark'
            ? theme.palette.grey[900]
            : theme.palette.grey[50],
          '& .MuiCardHeader-avatar': {
            marginRight: 2,
            color: theme.palette.primary.main,
          },
        }}
      />
      <Divider />
      {noPadding ? (
        <Box>{children}</Box>
      ) : (
        <CardContent>{children}</CardContent>
      )}
    </Card>
  );
};
